/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Files_Error_Causes_Retry_FailedInputs */



/**
* | output |
* | --- |
* | "Could not queue the files again." |
*
* @param {Files_Error_Causes_Retry_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const files_error_causes_retry_failed = /** @type {((inputs?: Files_Error_Causes_Retry_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Files_Error_Causes_Retry_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Dateien konnten nicht erneut eingereiht werden.")
	return /** @type {LocalizedString} */ ("Could not queue the files again.")
});